var MessageEn = {

  NavabarText: {
    navbar_home: "Home",
    navbar_about: "About Us",
    navbar_search: "Report",
    navbar_contact: "Contact Us",
    navbar_item: "Services",
    navbr_new:'News',
  },
  About_Navbar:{
    Company:'Company Overview',
    Horor:'Awards & Accreditation',
    Technology:'Technology ',
    Team:'Our Team ',
  },
  Item_NavBar:{
      YC_DNA_Test:'Y-Chromosome DNA Test ',
      Non_Prenatal_Test:'Non-invasive Prenatal Test ',
      Non_Paternity_Test:'Paternity Test (before birth or after birth)',
      Prenatal_And_Postpartum:'(Prenatal & Postpartum)',
  },
  
  New_NavBar:{
    Notice:'Notice',
    MediaCentre:'Media Center',
  },
  indexText: {
    more: "Learn more",

  },
  footText:{
    address:"Unit N, Floor 9, Valiant Industrial Centre, 2-12 Au Pui Wan Street, Fo Tan, N.T., Hong Kong.",
    address_prefix: "Unit N, Floor 9, Valiant Industrial Centre, 2-12 Au Pui Wan Street, Fo Tan, N.T., Hong Kong.",
    address_suffix: "",
    phone:"(+852) 3100 0477",
    email:"info@hkmedilab.com",
    weixin:"Scan the QR code",
    aboutUs:'About Us',
    company:'Company Overview',
    honor:'Awards & Accreditation',
    technology:'Technology ',
    team:'Our Team ',
    services:'Services',
    chromosomeText:'Y-Chromosome DNA Test ',
    invasivePrenatalTest:'Non-invasive Prenatal Test ',
    invasivePaterNityTest:'Paternity Test (before birth or after birth)',
    special:'(prenatal and post natal)',
    news:'News ',
    notice:'Notice',
    mediaCentre:'Media Center',
    report:'Report ',
    contact:'Contact Us',
    talentRecruitment:'Career',
    OfficeHours:'Office Hours',
    day1:'Monday – Friday',
    day2:'Saturday-Sunday',
    version:'All rights reserved(c) 2020 Hong Kong Medical Laboratory Centre Limited',
    privacy: 'Privacy policy',
    terms: 'Terms of use',
    Links1: 'HHLink',
    back:'Home'
  },
  ContractText:{
    name:'Name',
    code:'Laboratory No.',
    phone:'Phone No.',
    send_sms:'Send',
    send_sms_second:'Send Again',
    vertifys:'Verification code',
    mailbox_btn:'Confirm',
    speaker:'Spare',
    warning:'I acknowledge that I have read and agree ',
    statement:'the privacy policy.',
    report_search_description:'Instructions for Report Verification:',
    description_one:'Report verification is available 3 hours after the receiving of the report. ',
    description_two:'Please ensure the name and laboratory number you input is consistent with that on the report.',
    description_three:'Select your country code and input your mobile number, and then click " Send ". You will receive verification code. Input the verification code and click " Confirm ".',
    description_four:'If you fail to enquiry the report, please contact us at (+852) 3100 0477.',
    description_five:'The website only keeps your test report for one year. Please feel free to contact us if you have any enquiries.',
    cn:'CN(86)',
    hk:'HK(00852)',
    mo:'MO(00853)',
},

  HomeText:{
    p1_1_1:'Professional',
    p1_1_1_2:'on Y-Chromosome DNA Test',
    p1_1_2:'Can be tested from 6 weeks of pregnancy',
    p1_1_3:'Reporting in 5 hours',
    p1_2_1:'Hong Kong Medical Laboratory',
    p1_2_1_2:'Technologists Board approval',
    p1_2_2:'Famous brand in Hong Kong',
    p1_2_3:'High-end molecular technology',
    p1_2_3_2:'',
    p1_3_1:'專業',
    p1_3_2:'高效',
    p1_3_3:'精準',
    p1_3_4:'優質',
    // p1_3_1:'Professional',
    // p1_3_2:'Efficient',
    // p1_3_3:'Precise',
    // p1_3_4:'High Quality',

    p2_title:'HKMedi Lab, Your Preferable Choice, Your Best Choice',
    p2_action:'More Services',
    p2_item_action:'Details',
    p2_1:'Y-Chromosome DNA Test',
    p2_2:'Non-invasive Prenatal Test',
    p2_3:'Paternity Test',
    p2_3_add_on:'(before birth or after birth)',

    p3_title:'Laboratory Specifications',
    p3_content:'The operation of our laboratory is followed with the standard and guideline of ISO 9001 and ISO 17025. Our part 1 medical laboratory technologist of HKMLT Board take a role to monitor the whole operation process.  We promise to provide high quality report and result, also try our best to meet customer and regulatory requirement need.',

    p4_title:'Awards & Accreditation',
    p4_1:'Hong Kong Medical Laboratory',
    p4_1_2:'Technologists Board approval and recognized',
    p4_2:'Famous brand in Hong Kong',
    p4_3:'High-end molecular technology',

    p5_title:'Technology',
    p5_1_1:'Fully Automatic Equipment',
    p5_1_2:'Our advance laboratory equipment includes automatic DNA extraction system, precised liquid handling system and advanced gene analysis technology. Equipped with all these automatic technologies instead of manual technique, the contaminate risk can be effectively minimized.',
    p5_2_1:'Real-Time Polymerase Chain Reaction',
    p5_2_2:'We use the most advanced real-time PCR to amplify fetal DNA to huge amount and  quantify the Y-chromosomal DNA targets with fluorescent dyes simultaneously. The accurate result can be analyzed in a short time.',
    p5_3_1:'20 Unique Sequence Primers',
    p5_3_2:'We use 20 specific markers of Y chromosome DNA to analysis the final test result. This test is highly sensitive, and the accuracy reach to 99.9%.',

    p6_1:'Report',
    p6_1_2:'input...',
    p6_1_3:'Search',
    p6_2:'Hong Kong Medical Laboratory Centre'
  },
  AboutText: {
    p1_title: 'About Us',
    p1_action: 'Home',

    p2_title: 'Company Overview',
    p2_subtitle: 'About Hong Kong Medical Laboratory Centre',
    p2_content: 'We are leading by molecular diagnostic techniques and genetic techniques. Combined with advanced molecular testing equipment from oversea, self-developed genetic test technologies, comprehensive database and analysis by professional technical team. We are committed by providing the most professional, high-end and comprehensive one-stop genetic testing service to our valuable customers.',


    p3_title: 'Our Team',
    p3_subtitle: 'R&D Team',
    p3_content: "Our R&D team brings together the most authoritative experts in molecular genetic testing, including master and doctor level scientific consultants and qualified chemist and technician, who have rich practical clinical experience in the field of molecular diagnosis. The medical consultant covers the most comprehensive team of doctors and provides a wide range of medical information and advice.",

    p4_title: 'Our Mission',
    p4_content_1: "By using our professional knowledge, innovative and precise genetic technology, and",
    p4_content_2: "high-quality services, we do our best to provide the most accurate and comprehensive testing",
    p4_content_3: "to every valuable customer in order to improve the living standard of the next generation. We",
    p4_content_4: "are actively working with organizations around the world to maintain a leading position in",
    p4_content_5: "molecular testing and to increase public awareness of genetic testing.",
    p4_content_6: "",
    p4_content_7: "",

    p5_title: 'Our Culture',
    p5_1_1: 'People oriented',
    p5_1_2_1: 'Customer first, to provide accurate genetic testing according to customer needs',
    p5_1_2_2: '',
    p5_1_2_3: '',
    p5_2_1: 'Caring for employees',
    p5_2_2_1: 'employees first, create a platform for employees and enhance their personal value',
    p5_2_2_2: '',
    p5_2_2_3: '',
    p5_3_1: 'Integrity and responsibility',
    p5_3_2_1: 'Treat people with integrity and to build up trust and responsible relationships with customers',
    p5_3_2_2: '',
    p5_3_2_3: '',
    p5_4_1: 'Pursuit of excellence',
    p5_4_2_1: 'Continue to research and develop the innovative technology. Improve the quality of service and provide society with excellent products and services.',
    p5_4_2_2: '',
    p5_4_2_3: '',
  },
  ContactUsText:{
    p1_title: 'Contact Us',
    p1_action: 'Home',

    p2_title:'Get in touch',
    p2_action:'Send',
    p2_1:'Message',
    p2_2:'Name',
    p2_3:'Mobile No.',
    p2_4:'Email',

    p3_tel:'(+852) 3100 0477',
    p3_fax:'(+852) 3102 0345',
    p3_email:'info@hkmedilab.com',
    p3_address:'Unit 11, 13/F, Tower 1, Grand Central Plaza, 138 Shatin Rural Committee Road, Shatin, N.T., HK.',
  },
  YDnaTest: {
    p1_title: 'Y-Chromosome DNA Test',
    p1_action: 'Home',

    p2_title: 'Sex Chromosome',
    p2_content: "to determine the gender and the physical characteristics of and individual.",
    p2_content2: "Male= Chromosome X,Y  /  Female = Chromosome X,X",

    p3_title: "Fetal cell-free DNA in Mother's Blood",
    p3_content: "During pregnancy, fetal cell-free DNA (cffDNA) can be found in the maternal circulation, and its amount increased with gestation.",
    p3_content2: "At 6 weeks of pregnancy, sufficient cffDNA can be collected from maternal blood to identify Y chromosome target noninvasively.",
    p3_content3: "Extracted cffDNA will be amplified for detection by real-time polymerase chain reaction Paternity relationship",
    p3_content4: "Y chromosome of male is only inherited from his biological father.",
    p3_content5: "Y chromosome is one of genetic marker to approve paternity relation between the biological father and biological son.",

    p4_title: 'Paternity relationship',
    p4_content_1: "Y chromosome of male is only inherited from his biological father.",
    p4_content_2: "Y chromosome is one of genetic marker to approve paternity relation between the biological father and biological son.",

    p5_title: "Test Content",
    p5_1_1: "Test",
    p5_1_2: "Y-Chromosome DNA Test ≥6 weeks",
    p5_1_3: "Y-Chromosome DNA Test ≥6 weeks (URGENT)",
    p5_2_1: "Turnaround Time",
    p5_2_2: "1 Working Day ",
    p5_2_3: "5 Hours",
    p5_3_1: "Sample Requirements",
    p5_3_2: "6mL EDTA BCT x2",
    p5_3_3: "6mL EDTA BCT x2",

    advantages_title: "Advantages",
    advantages_1_1: "Express",
    advantages_1_2: "Reporting < 5 hours",
    advantages_2_1: "Accuracy",
    advantages_2_2: "99.9%",
    advantages_3_1: "Sensitive",
    advantages_3_2: "Detect as early as 6 weeks",
    advantages_4_1: "Non-invasive",
    advantages_4_2: "Maternal blood only",

    p7_title: "Service Procedures",
    p7_1: "Appointment Registration ",
    p7_2: "Blood Collection",
    p7_3: "Samples Transportation ",
    p7_4: "Samples Analysis ",
    p7_5: "Test Results",

    p8_title: "Attention",
    p8_1_1: "if you have the following situations",
    p8_1_2: "Please contact our professional team",

    p8_2_1: "1. Receiving organ transplant or blood transfusion within 6 months",
    p8_2_2: "2. Male born within 6 months",
    p8_2_3: "3. Triplets or more",
    p8_2_4: "4. IVF",
    p8_2_5: "5. The fetus is mosaicism",
  },
  NPrenatalTest: {
    p1_title: 'Non-invasive Prenatal Test',
    p1_action: 'Home',

    p2_content: "Sperm and eggs with chromosomal abnormalities occur randomly and increase with age, so every parent has a chance to give birth to a baby with chromosomal abnormalities.",
    p3_content: "There is no effective treatment for most of these diseases so far. All that can be done is to have prenatal screening earlier to reduce the chance of giving birth to the baby with genetic diseases. The American College of Obstetrics and Gynecology (ACOG) has listed non-invasive chromosomal genetic testing as a recommended item for prenatal screening.",
    p4_content: "Non-invasive prenatal screening is the most advanced technology currently. Different from traditional invasive methods such as chorionic villus sampling and amniocentesis, only few mL of maternal blood is required with high accuracy and no miscarriage risk. Using polymerase chain reaction (PCR) and next-generation sequencing (NGS) , genetic information of the baby can be obtained and compared with the genetic database to calculate the chance of inherited diseases. ",

    p5_title: "Chromosomal abnormalities can be divided into three categories:",
    p5_subtitle: "Chromosomal",
    p5_1_1: "polyploid or",
    p5_1_2: "aneuploid",
    p5_2_1: "Microdeletion",
    p5_3_1: "Gene Mutation",

    p6_title: "Comparison of Prenatal Tests",
    p6_content: "Non-invasive prenatal genetic testing is a very safe and highly accurate non-invasive prenatal screening technology. Compared with traditional invasive prenatal diagnostic methods (e.g. amniocentesis), NIPT is a safe method of prenatal testing, which will not cause miscarriage nor infection. The accuracy is higher than 99%. Just draw a small amount of maternal blood to check whether the baby has a potential risk of disease. ",

    advantages_title: "Advantages",
    advantages_1_1: "Express",
    advantages_1_2: "Reporting in 5-7 WD",
    advantages_2_1: "Accuracy",
    advantages_2_2: "99%",
    advantages_3_1: "Sensitive",
    advantages_3_2: "Detect as early as 10 weeks",
    advantages_4_1: "Non-invasive",
    advantages_4_2: "Maternal blood only",

    p7_1_1: "Test",
    p7_1_2: "Non-Invasive Prenatal Test",
    p7_1_3: "Amniocentesis",
    p7_1_4: "Chorionic Villus Sampling",
    p7_1_5: "Nuchal Translucency(NT) ",
    p7_1_6: "Early pregnancy screening",
    p7_1_7: "Mid-pregnancy screening",
    p7_1_8: "Percutaneous Umbilical Cord Blood Sampling",
    p7_2_1: "Accuracy",
    p7_2_2: ">99%",
    p7_2_3: ">99%",
    p7_2_4: ">99%",
    p7_2_5: "60%-80%",
    p7_2_6: "80%-90%",
    p7_2_7: "60%-90%",
    p7_2_8: ">99%",
    p7_3_1: "Gestational Week",
    p7_3_2: "≥9",
    p7_3_3: "16-20",
    p7_3_4: "11-13",
    p7_3_5: "11-13",
    p7_3_6: "11-13",
    p7_3_7: "16-19",
    p7_3_8: ">20",
    p7_4_1: "Miscarriage Risk",
    p7_4_2: "/",
    p7_4_3: "0.5-1%",
    p7_4_4: "1-2%",
    p7_4_5: "/",
    p7_4_6: "/",
    p7_4_7: "/",
    p7_4_8: "1-2%",
    p7_5_1: "TAT(working day)",
    p7_5_2: "5-7",
    p7_5_3: "14-21",
    p7_5_4: "14-21",
    p7_5_5: "1-2",
    p7_5_6: "1-2",
    p7_5_7: "1-2",
    p7_5_8: "5-7",
  },
  PaternityTest: {
    p1_title: 'Paternity Test',
    p1_title_2: '(before birth or after birth)',
    p1_action: 'Home',
    p2_content: 'Both boys and girls have two sets of chromosomes, one is inherited from father and the other is inherited from mother. Baby\'s DNA is compared with other individual to confirm their paternity with an accuracy rate of 99.99%.',

    p3_title:'Non-invasive',
    p3_subtitle:'Paternity Test',
    p3_1:"During pregnancy, fetal DNA fragments enter the mother's circulatory system through the placenta. Sufficient fetal DNA fragments can be collected from maternal blood from the 7 weeks of pregnancy without invasively taking any fetal tissues. Comparing with traditional amniocentesis or chorionic villi sampling, it is a safe method without any miscarriage risk. ",
    p3_2:'Samples:',
    p3_2_1:'Blood, Buccal Swab, Nails, 5-10 Hairs with Follicles',
    p3_3:'Target Group:',
    p3_3_1:'Father and son/daughter',
    p4_title:'Paternity',
    p4_subtitle:'Test',
    p4_1:'DNA can be used not only to determine paternity between children and parents,',
    p4_1_1:'but also to determine kinship and whether two people are related by blood.',
    p4_2:'Samples:',
    p4_2_1:'Blood, Buccal Swab, Nails, 5-10 Hairs with Follicles',
    p4_3:'Target Group:',
    p4_3_1:'Father and son/daughter',
    p4_3_2:'Brothers and sisters (same father & mother)',
    p4_3_3:'Uncle and nephew',
    p4_3_4:'Mother and son/daughter',
    p4_3_5:'Grandparents',

    advantages_title: "Advantages",
    advantages_1_1: "Express",
    advantages_1_2: "Reporting in 3-5 WD",
    advantages_2_1: "Accuracy",
    advantages_2_2: "99.99%",
    advantages_3_1: "Sensitive",
    advantages_3_2: "Detect as early as 7 weeks",
    advantages_4_1: "Non-invasive",
    advantages_4_2: "Maternal blood only",
    advantages_4_2_1: "(Before birth)",
  },
};

export {
  MessageEn
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js